/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface TotalEnergyConsumption
 */
export interface TotalEnergyConsumption {
    /**
     *
     * @type {string}
     * @memberof TotalEnergyConsumption
     */
    deviceIdentity?: string;
    /**
     *
     * @type {number}
     * @memberof TotalEnergyConsumption
     */
    consumptionWh?: number;
    /**
     * Percentage difference in energy consumption (based on ConsumptionWh) from the previous period, can be null if previous period does not have data.
     * @type {number}
     * @memberof TotalEnergyConsumption
     */
    diffPercentage?: number;
}

/**
 * Check if a given object implements the TotalEnergyConsumption interface.
 */
export function instanceOfTotalEnergyConsumption(
    value: object,
): value is TotalEnergyConsumption {
    return true;
}

export function TotalEnergyConsumptionFromJSON(
    json: any,
): TotalEnergyConsumption {
    return TotalEnergyConsumptionFromJSONTyped(json, false);
}

export function TotalEnergyConsumptionFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): TotalEnergyConsumption {
    if (json == null) {
        return json;
    }
    return {
        deviceIdentity:
            json["deviceIdentity"] == null ? undefined : json["deviceIdentity"],
        consumptionWh:
            json["consumptionWh"] == null ? undefined : json["consumptionWh"],
        diffPercentage:
            json["diffPercentage"] == null ? undefined : json["diffPercentage"],
    };
}

export function TotalEnergyConsumptionToJSON(
    value?: TotalEnergyConsumption | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        deviceIdentity: value["deviceIdentity"],
        consumptionWh: value["consumptionWh"],
        diffPercentage: value["diffPercentage"],
    };
}
